var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.975,
    height: 18.975,
    viewBox: "0 0 18.975 18.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3989",
    "data-name": "Group 3989",
    transform: "translate(-361.107 -3063.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_9",
    "data-name": "Union 9",
    d: "M.463,18.512a1.583,1.583,0,0,1,0-2.239L7.25,9.487.467,2.7a1.58,1.58,0,0,1,0-2.238h0A1.581,1.581,0,0,1,2.7.465L9.488,7.25,16.273.465a1.58,1.58,0,0,1,2.235,0h0a1.582,1.582,0,0,1,0,2.238L11.726,9.488l6.785,6.785a1.582,1.582,0,1,1-2.236,2.239L9.489,11.725,2.7,18.512a1.583,1.583,0,0,1-2.239,0Z",
    transform: "translate(361.107 3063.512)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.2bd4aa717a7a909eb8ed6c45cdc57d1e.svg";
export { ForwardRef as ReactComponent };